import React from "react";
import {
  Container,
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Link,
  Divider,
} from "@mui/material";
import ReactPlayer from "react-player/vimeo"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";

import NotificationImg from "../assets/LandingPage/NotificationImg.png"

const HelpFAQPage = () => {
  const { t } = useTranslation();

  // Arrays aus i18n (mit Objekten {label, href})
  const browsers =
    t("helpFaq.notifications.browserSettings.browsers", {
      returnObjects: true,
    }) || [];
  const systems =
    t("helpFaq.notifications.osSettings.systems", { returnObjects: true }) ||
    [];
  const faqs = t("helpFaq.faqs", { returnObjects: true }) || [];

  return (
    <Container
      
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2,
      }}
    >
      <Box
        className="white-background"
        sx={{
          width: "100%",
          maxWidth: "100%",
          p: { xs: 2, sm: 4 },
          borderRadius: 2,
          textAlign: "left",
          overflowY: "auto",
        }}
      >
        {/* Titel + Untertitel */}
        <Typography variant="h3" color="primary" gutterBottom>
          {t("helpFaq.title")}
        </Typography>
        {!!t("helpFaq.subtitle") && (
          <Typography variant="h6" gutterBottom>
            {t("helpFaq.subtitle")}
          </Typography>
        )}

        <Divider sx={{ my: 3 }} />
        
        <Box sx={{display:"flex", justifyContent:"center", marginBottom:5}}>
          <ReactPlayer 
          url="https://vimeo.com/1033152791"
          controls
          width="100%"
          light={true} // shows thumbnail until play
          playing={true}
          />
        </Box>

        {/* Notifications – Setup */}
        <Typography variant="h5" color="primary" gutterBottom sx={{fontWeight:"bold"}}>
          {t("helpFaq.notifications.title")}
        </Typography>
        <Typography paragraph>{t("helpFaq.notifications.text")}</Typography>
        <Box sx={{my:5, display:"flex", justifyContent:"center"}}>
          <img src={NotificationImg} alt="Notifications" style={{width:"100%", borderRadius:15}}/>
        </Box>

        {/* Browser-Einstellungen */}
        <Typography variant="h6" gutterBottom sx={{ mt: 1, fontWeight:"bold" }}>
          {t("helpFaq.notifications.browserSettings.title")}
        </Typography>
        {browsers.map((b, idx) => (
          <Typography key={idx} sx={{ mb: 0.5 }}>
            <Link
              href={b.href}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
            >
              {b.label}
            </Link>
          </Typography>
        ))}

        {/* Betriebssystem-Einstellungen */}
        <Typography variant="h6" gutterBottom sx={{ mt: 2, fontWeight:"bold" }}>
          {t("helpFaq.notifications.osSettings.title")}
        </Typography>
        {systems.map((s, idx) => (
          <Typography key={idx} sx={{ mb: 0.5 }}>
            <Link
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
            >
              {s.label}
            </Link>
          </Typography>
        ))}
        

        <Divider sx={{ my: 3 }} />

        {/* FAQs */}
        <Typography variant="h5" color="primary" gutterBottom>
          {t("helpFaq.faqsTitle")}
        </Typography>

        {faqs.map((faq, idx) => (
          <Accordion key={idx} disableGutters>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1" fontWeight={600}>
                {faq.q}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1">{faq.a}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Container>
  );
};

export default HelpFAQPage;
